module.exports = __webpack_public_path__ + "assets/img/panel-l.f69de5f1.svg";